import { Tab, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function FileTab(props) {
  const handleClickTab = () => {
    props.handleAction();
  };
  return (
    <Tab
      onClick={handleClickTab}
      /*       onClick={handleClickTab(props.item.id, props.item.fileName, props.item.fileContent)} */
      label={
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            maxWidth: 350,
          }}
        >
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {props.item.fileName}
          </span>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation(); //não ativa a tab
              props.handleDeleteFile(props.item.id);
            }}
            sx={{
              padding: "2px",
              color: "rgb(166,166,166)",
              "&:hover": {
                color: "white",
                backgroundColor: "rgba(255,255,255,0.1)",
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      }
      sx={{
        whiteSpace: "nowrap",
        textTransform: "none",
        padding: "5px",

        borderRight: "1px solid rgba(109, 109, 109, 0.12)",
        backgroundColor: props.selected ? "none" : "rgba(109, 109, 109, 0.12)",
        color: "rgb(166, 166, 166)",
        borderTop: props.selected ? "solid 2px #ff5722" : "solid 2px transparent",
        opacity: 1,
        "&.Mui-selected": {
          opacity: 1,
        },
      }}
    />
  );
}
